import { render, staticRenderFns } from "./Selfie.vue?vue&type=template&id=7fa1175f"
import script from "./Selfie.vue?vue&type=script&lang=js"
export * from "./Selfie.vue?vue&type=script&lang=js"
import style0 from "./Selfie.vue?vue&type=style&index=0&id=7fa1175f&prod&lang=less"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports